import { cardsData } from '@/mocks/homeData';

export default function CardsSection() {
  return (
    <section id="cards" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[1300px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            实用指南
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-[500px] mx-auto">
            观影技巧与平台使用攻略，让每一次观影都更尽兴
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {cardsData.slice(0, 3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-primary-200/50 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center rounded-lg bg-background-950/70 text-background-50">
                  <i className={`${item.icon} text-sm`}></i>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 md:gap-6 mt-5 md:mt-6">
          {cardsData.slice(3).map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-lg overflow-hidden border border-background-200/60 hover:border-secondary-200/50 transition-all cursor-pointer"
            >
              <div className="relative aspect-[3/2] overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    target.style.display = 'none';
                    (target.parentElement as HTMLElement).style.display = 'none';
                  }}
                />
                <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center rounded-lg bg-background-950/70 text-background-50">
                  <i className={`${item.icon} text-sm`}></i>
                </div>
              </div>
              <div className="p-5">
                <div className="flex items-center gap-2 mb-2">
                  <span className="text-[11px] text-foreground-500">{item.date}</span>
                </div>
                <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="mt-2 text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {item.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}